module.exports = __webpack_public_path__ + "media/images/logor-8c3a9597be9a6276b8d64bf6b63add52.png";